import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import AnnouncementChecker from "@/components/AnnouncementChecker";
import RequireSuperAdminRoute from "@/components/RequireSuperAdminRoute";
import RoutePage from "@/components/RoutePage";
import { lazyPage, registerPagePreloaders } from "@/utils/routePreload";



























import { PlanningDraftSessionProvider } from "@/components/mfg/PlanningDraftSession";

import { MANUFACTURING_TIME_PERMISSIONS, routePermissionAllowed } from "@/navigation";
















import { PermissionProvider, usePerms } from "@/PermissionContext";





import BirthdayPopup from "@/components/BirthdayPopup";
import ProfileReminderPopup from "@/components/ProfileReminderPopup";
import IndiaHolidayDecor from "@/components/IndiaHolidayDecor";
import DiwaliDecor from "@/components/DiwaliDecor";
import api from "@/api";




const lazyDefault = lazyPage;
const lazyNamed = lazyPage;

const LoginAnnouncements = lazyDefault(() => import("@/pages/LoginAnnouncements"));
const Login = lazyDefault(() => import("@/pages/Login"));
const Register = lazyDefault(() => import("@/pages/Register"));
const Customers = lazyDefault(() => import("@/pages/Customers"));
const DocList = lazyNamed(() => import("@/pages/DocumentList"), "DocList");
const DocBuilder = lazyNamed(() => import("@/pages/Documents"), "DocBuilder");
const DocDetail = lazyNamed(() => import("@/pages/Documents"), "DocDetail");
const QuotationRevision = lazyDefault(() => import("@/pages/QuotationRevision"));
const Templates = lazyNamed(() => import("@/pages/Masters"), "Templates");
const Hsn = lazyNamed(() => import("@/pages/Masters"), "Hsn");
const Banks = lazyNamed(() => import("@/pages/Masters"), "Banks");
const Users = lazyNamed(() => import("@/pages/Masters"), "Users");
const Migration = lazyNamed(() => import("@/pages/Masters"), "Migration");
const DataImport = lazyDefault(() => import("@/pages/DataImport"));
const DataHealth = lazyDefault(() => import("@/pages/DataHealth"));
const AdminReset = lazyDefault(() => import("@/pages/AdminReset"));
const Customer360 = lazyDefault(() => import("@/pages/Customer360"));
const WorkOrdersList = lazyNamed(() => import("@/pages/WorkOrdersList"), "WorkOrdersList");
const WorkOrderDetail = lazyNamed(() => import("@/pages/WorkOrders"), "WorkOrderDetail");
const VendorsList = lazyNamed(() => import("@/pages/Vendors"), "VendorsList");
const VendorDetail = lazyNamed(() => import("@/pages/Vendors"), "VendorDetail");
const RawMaterialsList = lazyNamed(() => import("@/pages/RawMaterials"), "RawMaterialsList");
const RawMaterialDetail = lazyNamed(() => import("@/pages/RawMaterials"), "RawMaterialDetail");
const StoreMaterialIssues = lazyDefault(() => import("@/pages/StoreMaterialIssues"));
const StoreMaterialsList = lazyNamed(() => import("@/pages/StoreMaterials"), "StoreMaterialsList");
const StoreMaterialDetail = lazyNamed(() => import("@/pages/StoreMaterials"), "StoreMaterialDetail");
const StoreReceivingQueue = lazyNamed(() => import("@/pages/StoreReceiving"), "StoreReceivingQueue");
const StoreReceivingDetail = lazyNamed(() => import("@/pages/StoreReceiving"), "StoreReceivingDetail");
const VMMList = lazyNamed(() => import("@/pages/VendorMaterialMapping"), "VMMList");
const VMMDetail = lazyNamed(() => import("@/pages/VendorMaterialMapping"), "VMMDetail");
const VMMRecommend = lazyNamed(() => import("@/pages/VendorMaterialMapping"), "VMMRecommend");
const DeliveryChallansList = lazyNamed(() => import("@/pages/DeliveryChallans"), "DeliveryChallansList");
const DeliveryChallanDetail = lazyNamed(() => import("@/pages/DeliveryChallans"), "DeliveryChallanDetail");
const PurchaseOrdersList = lazyNamed(() => import("@/pages/Purchase"), "PurchaseOrdersList");
const PurchaseOrderBuilder = lazyNamed(() => import("@/pages/Purchase"), "PurchaseOrderBuilder");
const PurchaseOrderDetail = lazyNamed(() => import("@/pages/Purchase"), "PurchaseOrderDetail");
const NotesList = lazyNamed(() => import("@/pages/Purchase"), "NotesList");
const NoteBuilder = lazyNamed(() => import("@/pages/Purchase"), "NoteBuilder");
const NoteDetail = lazyNamed(() => import("@/pages/Purchase"), "NoteDetail");
const CustomerPOsList = lazyNamed(() => import("@/pages/CustomerPOs"), "CustomerPOsList");
const CustomerPOBuilder = lazyNamed(() => import("@/pages/CustomerPOs"), "CustomerPOBuilder");
const CustomerPODetail = lazyNamed(() => import("@/pages/CustomerPOs"), "CustomerPODetail");
const PendingOrders = lazyDefault(() => import("@/pages/PendingOrders"));
const PartialBillingMgmt = lazyDefault(() => import("@/pages/PartialBillingMgmt"));
const ReceiptsList = lazyNamed(() => import("@/pages/Receipts"), "ReceiptsList");
const ReceiptBuilder = lazyNamed(() => import("@/pages/Receipts"), "ReceiptBuilder");
const ReceiptDetail = lazyNamed(() => import("@/pages/Receipts"), "ReceiptDetail");
const OutstandingReport = lazyNamed(() => import("@/pages/Receipts"), "OutstandingReport");
const CustomerLedger = lazyNamed(() => import("@/pages/Receipts"), "CustomerLedger");
const SmartDashboard = lazyNamed(() => import("@/pages/Reports"), "SmartDashboard");
const ReportsHub = lazyNamed(() => import("@/pages/Reports"), "ReportsHub");
const WOProductionPage = lazyNamed(() => import("@/pages/Production"), "WOProductionPage");
const ProductionBoard = lazyNamed(() => import("@/pages/Production"), "ProductionBoard");
const MfgWorkflow = lazyDefault(() => import("@/pages/MfgWorkflow"));
const ProductionPlanning = lazyDefault(() => import("@/pages/ProductionPlanning"));
const ManufacturingTimeReport = lazyDefault(() => import("@/pages/ManufacturingTimeReport"));
const ProductionNCsList = lazyNamed(() => import("@/pages/ProductionNCs"), "ProductionNCsList");
const ProductionNCsDetail = lazyNamed(() => import("@/pages/ProductionNCs"), "ProductionNCsDetail");
const PurchaseRequisitions = lazyDefault(() => import("@/pages/PurchaseRequisitions"));
const MaterialReceiptDetail = lazyNamed(() => import("@/pages/MaterialReceipts"), "MaterialReceiptDetail");
const MaterialReceiptsList = lazyNamed(() => import("@/pages/MaterialReceipts"), "MaterialReceiptsList");
const ProductSpecPage = lazyDefault(() => import("@/pages/ProductSpecPage"));
const MigrationReviewUnmatchedDetail = lazyNamed(() => import("@/pages/MigrationReview"), "MigrationReviewUnmatchedDetail");
const MigrationReviewAmbiguousDetail = lazyNamed(() => import("@/pages/MigrationReview"), "MigrationReviewAmbiguousDetail");
const SmtpSettings = lazyDefault(() => import("@/pages/SmtpSettings"));
const CompanySetup = lazyDefault(() => import("@/pages/CompanySetup"));
const MgmtReports = lazyDefault(() => import("@/pages/MgmtReports"));
const InactiveCustomersList = lazyDefault(() => import("@/pages/InactiveCustomersList"));
const MissingOrders = lazyDefault(() => import("@/pages/MissingOrders"));
const SMLeadsList = lazyNamed(() => import("@/pages/SalesMarketing"), "SMLeadsList");
const SMLeadDetail = lazyNamed(() => import("@/pages/SalesMarketing"), "SMLeadDetail");
const SMToday = lazyDefault(() => import("@/pages/SMToday"));
const SMRoutes = lazyDefault(() => import("@/pages/SMRoutes"));
const SMDashboard = lazyDefault(() => import("@/pages/SMDashboard"));
const EmailTemplates = lazyDefault(() => import("@/pages/EmailTemplates"));
const EmailActivity = lazyDefault(() => import("@/pages/EmailActivity"));
const UsersAdmin = lazyDefault(() => import("@/pages/UsersAdmin"));
const MyProfile = lazyDefault(() => import("@/pages/MyProfile"));
const ChangePassword = lazyDefault(() => import("@/pages/ChangePassword"));
const CelebrationSettings = lazyDefault(() => import("@/pages/CelebrationSettings"));
const TerminologySettings = lazyDefault(() => import("@/pages/TerminologySettings"));
const ChatInbox = lazyDefault(() => import("@/chat/ChatExperience"));
const OverlayBrowserFixture = lazyDefault(() => import("@/browser-tests/OverlayBrowserFixture"));
const UnitMaster = lazyDefault(() => import("@/pages/UnitMaster"));
const GSTDashboard = lazyNamed(() => import("@/pages/gst/GSTModule"), "GSTDashboard");
const GSTR1Page = lazyNamed(() => import("@/pages/gst/GSTModule"), "GSTR1Page");
const GSTR2BPage = lazyNamed(() => import("@/pages/gst/GSTModule"), "GSTR2BPage");
const TaxLiabilityPage = lazyNamed(() => import("@/pages/gst/GSTModule"), "TaxLiabilityPage");
const ITCPage = lazyNamed(() => import("@/pages/gst/GSTModule"), "ITCPage");
const HSNSummaryPage = lazyNamed(() => import("@/pages/gst/GSTModule"), "HSNSummaryPage");
const EInvoicePage = lazyNamed(() => import("@/pages/gst/GSTModule"), "EInvoicePage");
const EWayBillPage = lazyNamed(() => import("@/pages/gst/GSTModule"), "EWayBillPage");
const GSTReturnsPage = lazyNamed(() => import("@/pages/gst/GSTModule"), "GSTReturnsPage");
const GSTReportsPage = lazyNamed(() => import("@/pages/gst/GSTModule"), "GSTReportsPage");

// Exact sidebar destinations only; query parameters select a floor within the
// same module. Do not eagerly fetch every page or any business data.
registerPagePreloaders({
  "/": SmartDashboard, "/reports": ReportsHub,
  "/customers": Customers, "/quotations": DocList, "/proformas": DocList,
  "/invoices": DocList, "/work-orders": WorkOrdersList,
  "/manufacturing": MfgWorkflow, "/production-planning": ProductionPlanning,
  "/production-ncs": ProductionNCsList, "/production-board": ProductionBoard,
  "/customer-pos": CustomerPOsList, "/delivery-challans": DeliveryChallansList,
  "/purchase-orders": PurchaseOrdersList, "/vendors": VendorsList,
  "/raw-materials": RawMaterialsList, "/vendor-material-mapping": VMMList,
  "/material-receipts": MaterialReceiptsList, "/purchase-requisitions": PurchaseRequisitions,
  "/receipts": ReceiptsList, "/outstanding": OutstandingReport,
  "/store/materials": StoreMaterialsList, "/store/receiving": StoreReceivingQueue,
  "/store/material-issues": StoreMaterialIssues,
  "/reports/manufacturing-time": ManufacturingTimeReport,
  "/users": UsersAdmin, "/profile": MyProfile, "/chat": ChatInbox,
});

function Protected({ children }) {
  const { user, ready } = useAuth();
  const { forceChangePassword, ready: pready } = usePerms();
  const loc = useLocation();
  let page = children;
  while (React.isValidElement(page) && !page.type?.preload) page = page.props.children;
  const preload = page?.type?.preload;
  React.useEffect(() => {
    // Start route scripts alongside permission resolution, not after it.
    // This does not mount the page or bypass RequirePermRoute.
    if (ready && user && preload) preload().catch(() => {});
  }, [ready, user, preload]);
  if (!ready) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) {
    const summaryIntent = new URLSearchParams(loc.search).get("notifications") === "open";
    return <Navigate to={summaryIntent
      ? `/login?next=${encodeURIComponent(loc.pathname + loc.search)}`
      : "/login"} replace />;
  }
  // Once permissions have loaded, gate ALL non-change-password pages
  if (pready && forceChangePassword && loc.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return <Layout><RoutePage>{children}</RoutePage></Layout>;
}

/** Checks if today is the user's birthday and shows the BirthdayPopup once per day. */
function BirthdayChecker() {
  const { user, ready } = useAuth();
  const [celebration, setCelebration] = React.useState(null);
  const [show, setShow] = React.useState(false);
  const [companyLogo, setCompanyLogo] = React.useState(null);

  React.useEffect(() => {
    if (!ready || !user) return;
    const today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" }); // YYYY-MM-DD
    const key = `bday_popup_shown_${user.id}_${today}`;
    if (localStorage.getItem(key)) return;

    api.get("/celebrations/my-today")
      .then(r => {
        const data = r.data;
        if (data.is_birthday && data.settings?.birthday_popup !== false) {
          setCelebration(data);
          setShow(true);
          // Also fetch company logo
          api.get("/company-profile")
            .then(cp => setCompanyLogo(cp.data?.basic?.logo_url || null))
            .catch(() => {});
        }
      })
      .catch(() => {});
  }, [ready, user]);

  const dismiss = () => {
    const today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    const key = `bday_popup_shown_${user?.id}_${today}`;
    localStorage.setItem(key, "1");
    setShow(false);
  };

  if (!show || !celebration) return null;
  return (
    <BirthdayPopup
      name={celebration.name}
      logoUrl={companyLogo}
      photoUrl={user?.profile_photo_url}
      onClose={dismiss}
    />
  );
}

/* ── fields that must be filled for "profile complete" ───────────────────── */
const PROFILE_REQUIRED_KEYS = [
  "date_of_birth",
  "gender",
  "blood_group",
  "marital_status",
  "emergency_contact_name",
  "emergency_contact_number",
];

/**
 * ProfileReminderChecker — shows a friendly popup once per session-day
 * when the logged-in user has unfilled required profile fields.
 * Skipped on /login, /register, /change-password, and /profile itself.
 */
function ProfileReminderChecker() {
  const { user, ready } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = React.useState(false);
  const [missingFields, setMissingFields] = React.useState([]);
  const timerRef = React.useRef(null);

  React.useEffect(() => {
    // Pages where we never show the reminder
    const SKIP_PATHS = ["/login", "/register", "/change-password", "/profile"];
    const onSkipPath = SKIP_PATHS.some(p => location.pathname === p || location.pathname.startsWith(p));

    if (!ready || !user || onSkipPath) { setShow(false); return; }

    // IST date string used as the snooze key
    const today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    const snoozeKey = `profile_reminder_snoozed_${user.id}_${today}`;
    if (localStorage.getItem(snoozeKey)) return;

    // Compute missing fields
    const missing = PROFILE_REQUIRED_KEYS.filter(k => !user[k]);
    if (missing.length === 0) { setShow(false); return; }

    setMissingFields(missing);

    // Small delay so it doesn't flash immediately on login
    timerRef.current = setTimeout(() => setShow(true), 2000);
    return () => clearTimeout(timerRef.current);
  }, [ready, user, location.pathname]); // re-evaluate when user changes (after profile save)

  const snooze = () => {
    const today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    localStorage.setItem(`profile_reminder_snoozed_${user?.id}_${today}`, "1");
    setShow(false);
  };

  const completeNow = () => {
    setShow(false);
    navigate("/profile");
  };

  if (!show || missingFields.length === 0) return null;
  return (
    <ProfileReminderPopup
      missingFields={missingFields}
      onCompleteNow={completeNow}
      onSnooze={snooze}
    />
  );
}

/** Route-level permission guard.  Redirects to home if the user
 *  lacks the required permission (so URL access matches sidebar visibility). */
function RequirePermRoute({ module, action, any, adminOnly, financeOnly, children }) {
  const { can, ready, roleCodes, financeRestricted } = usePerms();
  if (!ready) return <div className="p-10 text-slate-500">Loading…</div>;
  const allowed = routePermissionAllowed(
    { module, action, any, adminOnly, financeOnly },
    can, roleCodes, financeRestricted,
  );
  if (!allowed) return <Navigate to="/profile" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <PermissionProvider>
      <PlanningDraftSessionProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <IndiaHolidayDecor />
        <DiwaliDecor />
        <AnnouncementChecker />
        <BirthdayChecker />
        <ProfileReminderChecker />
        <Routes>
          <Route path="/login" element={<RoutePage><Login /></RoutePage>} />
          <Route path="/register" element={<RoutePage><Register /></RoutePage>} />

          {/* Change password page — accessible without Layout wrapping only when forced */}
          <Route path="/change-password" element={<ChangePasswordRoute />} />

          <Route path="/" element={<Protected><RequirePermRoute module="dashboard" action="view"><SmartDashboard /></RequirePermRoute></Protected>} />
          <Route path="/chat" element={<Protected><ChatInbox /></Protected>} />
          {process.env.REACT_APP_BROWSER_TESTS === "true" && <Route path="/__overlay-browser-test" element={<Protected><OverlayBrowserFixture /></Protected>} />}
          <Route path="/reports" element={<Protected><RequirePermRoute module="reports"><ReportsHub /></RequirePermRoute></Protected>} />
          <Route path="/reports/manufacturing-time" element={<Protected><RequirePermRoute any={MANUFACTURING_TIME_PERMISSIONS}><ManufacturingTimeReport /></RequirePermRoute></Protected>} />
          <Route path="/production-board" element={<Protected><RequirePermRoute module="work_orders"><ProductionBoard /></RequirePermRoute></Protected>} />
          <Route path="/work-orders/:id/production" element={<Protected><RequirePermRoute module="work_orders"><WOProductionPage /></RequirePermRoute></Protected>} />
          <Route path="/manufacturing" element={<Protected><RequirePermRoute any={["work_orders", "preparation_floor", "production_floor", "qc_floor", "packing_floor", "dispatch_floor", "invoices"].map(mod => [mod, "view"])}><MfgWorkflow /></RequirePermRoute></Protected>} />
          <Route path="/production-planning" element={<Protected><RequirePermRoute any={[["production_planning","view"],["production_planning","manage"]]}><ProductionPlanning /></RequirePermRoute></Protected>} />
          <Route path="/production-ncs" element={<Protected><RequirePermRoute module="production_nc"><ProductionNCsList /></RequirePermRoute></Protected>} />
          <Route path="/production-ncs/:id" element={<Protected><RequirePermRoute module="production_nc"><ProductionNCsDetail /></RequirePermRoute></Protected>} />
          <Route path="/legacy-dashboard" element={<Navigate to="/" replace />} />
          <Route path="/customers" element={<Protected><RequirePermRoute module="customers"><Customers /></RequirePermRoute></Protected>} />
          <Route path="/customers/:cid" element={<Protected><RequirePermRoute module="customers"><Customer360 /></RequirePermRoute></Protected>} />
          <Route path="/templates" element={<Protected><RequirePermRoute module="product_templates"><Templates /></RequirePermRoute></Protected>} />

          <Route path="/quotations" element={<Protected><RequirePermRoute module="quotations"><DocList docType="quotation" title="Quotations" /></RequirePermRoute></Protected>} />
          <Route path="/quotations/new" element={<Protected><RequirePermRoute module="quotations" action="create"><DocBuilder docType="quotation" title="Quotations" /></RequirePermRoute></Protected>} />
          <Route path="/quotations/:id/revise" element={<Protected><RequirePermRoute module="quotations" action="create"><QuotationRevision /></RequirePermRoute></Protected>} />
          <Route path="/quotations/:id" element={<Protected><RequirePermRoute module="quotations"><DocDetail docType="quotation" title="Quotations" /></RequirePermRoute></Protected>} />

          <Route path="/proformas" element={<Protected><RequirePermRoute module="proformas"><DocList docType="proforma" title="Proformas" /></RequirePermRoute></Protected>} />
          <Route path="/proformas/new" element={<Protected><RequirePermRoute module="proformas" action="create"><DocBuilder docType="proforma" title="Proformas" /></RequirePermRoute></Protected>} />
          <Route path="/proformas/:id" element={<Protected><RequirePermRoute module="proformas"><DocDetail docType="proforma" title="Proformas" /></RequirePermRoute></Protected>} />

          <Route path="/invoices" element={<Protected><RequirePermRoute module="invoices"><DocList docType="invoice" title="Sales Invoices" /></RequirePermRoute></Protected>} />
          <Route path="/invoices/new" element={<Protected><RequirePermRoute module="invoices" action="create"><DocBuilder docType="invoice" title="Sales Invoices" /></RequirePermRoute></Protected>} />
          <Route path="/invoices/:id" element={<Protected><RequirePermRoute module="invoices"><DocDetail docType="invoice" title="Sales Invoices" /></RequirePermRoute></Protected>} />

          <Route path="/hsn" element={<Protected><RequirePermRoute module="hsn_codes"><Hsn /></RequirePermRoute></Protected>} />
          <Route path="/units" element={<Protected><RequirePermRoute adminOnly><UnitMaster /></RequirePermRoute></Protected>} />
          <Route path="/banks" element={<Protected><RequirePermRoute financeOnly module="banks"><Banks /></RequirePermRoute></Protected>} />
          <Route path="/work-orders" element={<Protected><RequirePermRoute module="work_orders"><WorkOrdersList /></RequirePermRoute></Protected>} />
          <Route path="/work-orders/:id" element={<Protected><RequirePermRoute module="work_orders"><WorkOrderDetail /></RequirePermRoute></Protected>} />

          <Route path="/vendors" element={<Protected><RequirePermRoute module="vendors"><VendorsList /></RequirePermRoute></Protected>} />
          <Route path="/vendors/:id" element={<Protected><RequirePermRoute module="vendors"><VendorDetail /></RequirePermRoute></Protected>} />

          <Route path="/raw-materials" element={<Protected><RequirePermRoute module="raw_materials"><RawMaterialsList /></RequirePermRoute></Protected>} />
          <Route path="/raw-materials/:id" element={<Protected><RequirePermRoute module="raw_materials"><RawMaterialDetail /></RequirePermRoute></Protected>} />
          <Route path="/store/materials" element={<Protected><RequirePermRoute module="inventory_movements" action="view"><StoreMaterialsList /></RequirePermRoute></Protected>} />
          <Route path="/store/materials/:id" element={<Protected><RequirePermRoute module="inventory_movements" action="view"><StoreMaterialDetail /></RequirePermRoute></Protected>} />
          <Route path="/store/material-issues" element={<Protected><RequirePermRoute module="inventory_movements" action="view"><StoreMaterialIssues /></RequirePermRoute></Protected>} />

          <Route path="/vendor-material-mappings" element={<Protected><RequirePermRoute module="vendor_material_mapping"><VMMList /></RequirePermRoute></Protected>} />
          <Route path="/vendor-material-mappings/recommend/:mid" element={<Protected><RequirePermRoute module="vendor_material_mapping"><VMMRecommend /></RequirePermRoute></Protected>} />
          <Route path="/vendor-material-mappings/:id" element={<Protected><RequirePermRoute module="vendor_material_mapping"><VMMDetail /></RequirePermRoute></Protected>} />

          <Route path="/delivery-challans" element={<Protected><RequirePermRoute module="delivery_challans"><DeliveryChallansList /></RequirePermRoute></Protected>} />
          <Route path="/delivery-challans/:id" element={<Protected><RequirePermRoute module="delivery_challans"><DeliveryChallanDetail /></RequirePermRoute></Protected>} />

          <Route path="/customer-pos" element={<Protected><RequirePermRoute module="customers"><CustomerPOsList /></RequirePermRoute></Protected>} />
          <Route path="/customer-pos/new" element={<Protected><RequirePermRoute module="customers" action="edit"><CustomerPOBuilder /></RequirePermRoute></Protected>} />
          <Route path="/customer-pos/:id" element={<Protected><RequirePermRoute module="customers"><CustomerPODetail /></RequirePermRoute></Protected>} />

          <Route path="/pending-orders" element={<Protected><RequirePermRoute module="work_orders"><PendingOrders /></RequirePermRoute></Protected>} />
          <Route path="/partial-billing" element={<Protected><RequirePermRoute module="invoices"><PartialBillingMgmt /></RequirePermRoute></Protected>} />

          <Route path="/receipts" element={<Protected><RequirePermRoute module="receipts"><ReceiptsList /></RequirePermRoute></Protected>} />
          <Route path="/receipts/new" element={<Protected><RequirePermRoute module="receipts" action="create"><ReceiptBuilder /></RequirePermRoute></Protected>} />
          <Route path="/receipts/:id" element={<Protected><RequirePermRoute module="receipts"><ReceiptDetail /></RequirePermRoute></Protected>} />
          <Route path="/outstanding" element={<Protected><RequirePermRoute financeOnly module="receipts"><OutstandingReport /></RequirePermRoute></Protected>} />
          <Route path="/customers/:id/ledger" element={<Protected><RequirePermRoute module="customers"><CustomerLedger /></RequirePermRoute></Protected>} />

          <Route path="/purchase-requisitions" element={<Protected><RequirePermRoute module="purchase_orders"><PurchaseRequisitions /></RequirePermRoute></Protected>} />
           <Route path="/material-receipts" element={<Protected><RequirePermRoute any={[["material_receipts","view"],["material_receipts","create"],["material_receipts","inspect"],["material_receipts","close"],["supplier_invoices","create"]]}><MaterialReceiptsList /></RequirePermRoute></Protected>} />
           <Route path="/material-receipts/:id" element={<Protected><RequirePermRoute any={[["material_receipts","view"],["material_receipts","create"],["material_receipts","inspect"],["material_receipts","close"],["supplier_invoices","create"],["purchase_orders","view"]]}><MaterialReceiptDetail /></RequirePermRoute></Protected>} />
          <Route path="/store/receiving" element={<Protected><RequirePermRoute any={[["material_receipts","view"],["material_receipts","create"],["material_receipts","inspect"]]}><StoreReceivingQueue /></RequirePermRoute></Protected>} />
          <Route path="/store/receiving/:id" element={<Protected><RequirePermRoute any={[["material_receipts","view"],["material_receipts","create"],["material_receipts","inspect"],["material_receipts","close"],["supplier_invoices","create"]]}><StoreReceivingDetail /></RequirePermRoute></Protected>} />
          <Route path="/purchase-orders" element={<Protected><RequirePermRoute module="purchase_orders" action="view"><PurchaseOrdersList /></RequirePermRoute></Protected>} />
          <Route path="/purchase-orders/new" element={<Protected><RequirePermRoute module="purchase_orders" action="create"><PurchaseOrderBuilder /></RequirePermRoute></Protected>} />
          <Route path="/purchase-orders/:id" element={<Protected><RequirePermRoute module="purchase_orders" action="view"><PurchaseOrderDetail /></RequirePermRoute></Protected>} />

          <Route path="/credit-notes" element={<Protected><RequirePermRoute financeOnly module="invoices"><NotesList noteType="credit_note" title="Credit Notes" /></RequirePermRoute></Protected>} />
          <Route path="/credit-notes/new" element={<Protected><RequirePermRoute financeOnly module="invoices" action="credit_note"><NoteBuilder noteType="credit_note" title="Credit Notes" /></RequirePermRoute></Protected>} />
          <Route path="/credit-notes/:id" element={<Protected><RequirePermRoute financeOnly module="invoices"><NoteDetail noteType="credit_note" title="Credit Notes" /></RequirePermRoute></Protected>} />

          <Route path="/debit-notes" element={<Protected><RequirePermRoute financeOnly module="invoices"><NotesList noteType="debit_note" title="Debit Notes" /></RequirePermRoute></Protected>} />
          <Route path="/debit-notes/new" element={<Protected><RequirePermRoute financeOnly module="invoices" action="credit_note"><NoteBuilder noteType="debit_note" title="Debit Notes" /></RequirePermRoute></Protected>} />
          <Route path="/debit-notes/:id" element={<Protected><RequirePermRoute financeOnly module="invoices"><NoteDetail noteType="debit_note" title="Debit Notes" /></RequirePermRoute></Protected>} />

          <Route path="/users" element={<Protected><RequirePermRoute module="users"><UsersAdmin /></RequirePermRoute></Protected>} />
          <Route path="/profile" element={<Protected><MyProfile /></Protected>} />

          {/* Data Import & Data Health — canonical routes */}
          <Route path="/data-import" element={<Protected><RequirePermRoute module="migration"><DataImport /></RequirePermRoute></Protected>} />
          <Route path="/admin/reset-company-data" element={<Protected><RequirePermRoute module="users"><AdminReset /></RequirePermRoute></Protected>} />
          <Route path="/migration-wizard" element={<Protected><RequirePermRoute module="migration"><Migration /></RequirePermRoute></Protected>} />
          <Route path="/data-health" element={<Protected><RequirePermRoute module="data_integrity"><DataHealth /></RequirePermRoute></Protected>} />

          {/* Legacy redirects — bookmarks and muscle memory */}
          <Route path="/migration"        element={<Navigate to="/data-import" replace />} />
          <Route path="/migration-center" element={<Navigate to="/data-import" replace />} />
          <Route path="/migration-engine" element={<Navigate to="/data-import" replace />} />
          <Route path="/data-integrity"   element={<Navigate to="/data-health" replace />} />
          <Route path="/review"           element={<Navigate to="/data-health?tab=customer_products" replace />} />
          <Route path="/migration-review" element={<Navigate to="/data-health?tab=unmatched" replace />} />

          {/* Detail pages still reachable from Data Health rows */}
          <Route path="/migration-review/unmatched/:id" element={<Protected><RequirePermRoute module="migration"><MigrationReviewUnmatchedDetail /></RequirePermRoute></Protected>} />
          <Route path="/migration-review/ambiguous/:id" element={<Protected><RequirePermRoute module="migration"><MigrationReviewAmbiguousDetail /></RequirePermRoute></Protected>} />
          <Route path="/settings/smtp"             element={<Protected><SmtpSettings /></Protected>} />
          <Route path="/settings/company"          element={<Protected><RequirePermRoute module="users"><CompanySetup /></RequirePermRoute></Protected>} />
          <Route path="/settings/business-reports" element={<Protected><RequirePermRoute module="users"><MgmtReports /></RequirePermRoute></Protected>} />
          <Route path="/settings/login-announcements" element={<Protected><RequireSuperAdminRoute><LoginAnnouncements /></RequireSuperAdminRoute></Protected>} />
          <Route path="/settings/celebrations"     element={<Protected><RequirePermRoute module="users"><CelebrationSettings /></RequirePermRoute></Protected>} />
          <Route path="/settings/terminology"      element={<Protected><RequirePermRoute module="users"><TerminologySettings /></RequirePermRoute></Protected>} />
          <Route path="/inactive-customers"        element={<Protected><RequirePermRoute module="customers"><InactiveCustomersList /></RequirePermRoute></Protected>} />
          <Route path="/missing-orders"           element={<Protected><RequirePermRoute module="reports"><MissingOrders /></RequirePermRoute></Protected>} />
          <Route path="/settings/email-templates"  element={<Protected><RequirePermRoute module="users"><EmailTemplates /></RequirePermRoute></Protected>} />
          <Route path="/email-activity"            element={<Protected><RequirePermRoute module="users"><EmailActivity /></RequirePermRoute></Protected>} />
          <Route path="/products/:id/spec"         element={<Protected><RequirePermRoute module="product_templates"><ProductSpecPage /></RequirePermRoute></Protected>} />

          {/* GST Module */}
          <Route path="/gst"               element={<Protected><RequirePermRoute module="gst"><GSTDashboard /></RequirePermRoute></Protected>} />
          <Route path="/gst/gstr1"         element={<Protected><RequirePermRoute module="gst"><GSTR1Page /></RequirePermRoute></Protected>} />
          <Route path="/gst/gstr2b"        element={<Protected><RequirePermRoute module="gst"><GSTR2BPage /></RequirePermRoute></Protected>} />
          <Route path="/gst/tax-liability" element={<Protected><RequirePermRoute module="gst"><TaxLiabilityPage /></RequirePermRoute></Protected>} />
          <Route path="/gst/itc"           element={<Protected><RequirePermRoute module="gst"><ITCPage /></RequirePermRoute></Protected>} />
          <Route path="/gst/hsn-summary"   element={<Protected><RequirePermRoute module="gst"><HSNSummaryPage /></RequirePermRoute></Protected>} />
          <Route path="/gst/einvoice"      element={<Protected><RequirePermRoute module="gst"><EInvoicePage /></RequirePermRoute></Protected>} />
          <Route path="/gst/eway-bill"     element={<Protected><RequirePermRoute module="gst"><EWayBillPage /></RequirePermRoute></Protected>} />
          <Route path="/gst/returns"       element={<Protected><RequirePermRoute module="gst"><GSTReturnsPage /></RequirePermRoute></Protected>} />
          <Route path="/gst/reports"       element={<Protected><RequirePermRoute module="gst"><GSTReportsPage /></RequirePermRoute></Protected>} />

          {/* Sales & Marketing module — Phase 1 + Phase 2 + Phase 3 */}
          <Route path="/sm/dashboard" element={<Protected><RequirePermRoute module="sales_marketing"><SMDashboard /></RequirePermRoute></Protected>} />
          <Route path="/sm/today"     element={<Protected><RequirePermRoute module="sales_marketing"><SMToday /></RequirePermRoute></Protected>} />
          <Route path="/sm/leads"     element={<Protected><RequirePermRoute module="sales_marketing"><SMLeadsList /></RequirePermRoute></Protected>} />
          <Route path="/sm/leads/:id" element={<Protected><RequirePermRoute module="sales_marketing"><SMLeadDetail /></RequirePermRoute></Protected>} />
          <Route path="/sm/routes"    element={<Protected><RequirePermRoute module="sales_marketing"><SMRoutes /></RequirePermRoute></Protected>} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      </PlanningDraftSessionProvider>
      </PermissionProvider>
    </AuthProvider>
  );
}


/** Change password route wrapper — allowed without full Layout (accessible during force-change). */
function ChangePasswordRoute() {
  const { user, ready } = useAuth();
  const { forceChangePassword } = usePerms();
  if (!ready) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <RoutePage><ChangePassword forced={forceChangePassword} /></RoutePage>;
}
